import type { Schemas } from '#shopware'
import { productCardIncludes } from './product'
import { productSortingIncludes } from './productSorting'
import { listingAggregationsIncludes } from './listingAggregations'

export const productListingIncludes: Schemas['Includes'] = {
    product_listing: [
        'elements',
        'sorting',
        'availableSortings',
        'currentFilters',
        'aggregations',
        'total',
        'limit',
        'page',
        'categoryTree',
        'a4gCurrentTeasers',
    ],
    ...productCardIncludes,
    ...productSortingIncludes,
    ...listingAggregationsIncludes,
}
